import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "torvi_cart_v1";
export const REWARD_THRESHOLD = 20000;

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      // Custom items always create new line
      if (item.custom_image || item.custom_text) {
        return [...prev, { ...item, quantity: item.quantity || 1, _lineId: Date.now() + Math.random() }];
      }
      const idx = prev.findIndex(
        (p) => p.product_id === item.product_id && !p.custom_image && !p.custom_text
      );
      if (idx >= 0) {
        const cp = [...prev];
        cp[idx] = { ...cp[idx], quantity: cp[idx].quantity + (item.quantity || 1) };
        return cp;
      }
      return [...prev, { ...item, quantity: item.quantity || 1, _lineId: Date.now() + Math.random() }];
    });
    setOpen(true);
  };

  const removeItem = (lineId) => setItems((p) => p.filter((i) => i._lineId !== lineId));
  const updateQty = (lineId, qty) =>
    setItems((p) => p.map((i) => (i._lineId === lineId ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const subtotal = useMemo(
    () => items.reduce((acc, i) => acc + i.price * i.quantity, 0),
    [items]
  );
  const hasGift = subtotal >= REWARD_THRESHOLD;
  const remaining = Math.max(0, REWARD_THRESHOLD - subtotal);
  const progress = Math.min(100, (subtotal / REWARD_THRESHOLD) * 100);
  const count = items.reduce((acc, i) => acc + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, removeItem, updateQty, clear, subtotal, hasGift, remaining, progress, count, open, setOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
